import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../store/store'
import { addToCart, updateQuantity, removeFromCart, clearCart } from '../store/slices/cartSlice'
import { CartItem } from '../types/cart'
import { analytics, cartItemToEventItem } from '../analytics'
import { CURRENCY } from '../analytics/config'
import { getCartItemUnitPrice } from '../utils/cartUtils'

export const useCart = () => {
  const dispatch = useDispatch()
  const cartItems = useSelector((state: RootState) => state.cart.items)

  const addItem = (item: CartItem) => {
    dispatch(addToCart(item))
    analytics.track('add_to_cart', {
      items: [cartItemToEventItem(item)],
      value: getCartItemUnitPrice(item) * item.quantity,
      currency: CURRENCY,
    })
  }

  const updateItemQuantity = (id: number, variationId: number | undefined, quantity: number) => {
    dispatch(updateQuantity({ id, variationId, quantity }))
  }

  const removeItem = (item: CartItem) => {
    dispatch(removeFromCart(item))
    analytics.track('remove_from_cart', {
      items: [cartItemToEventItem(item)],
      value: getCartItemUnitPrice(item) * item.quantity,
      currency: CURRENCY,
    })
  }

  const clearAll = () => {
    dispatch(clearCart())
  }

  return {
    cartItems,
    addItem,
    updateItemQuantity,
    removeItem,
    clearAll,
  }
}
